import { useCallback } from 'react';
import { useQueryClient } from '../../lib';
import { getAuthTokenKey, getNetworkKey } from '../../utils/keys';
export const useInvalidateNetworkQuery = () => {
    const queryClient = useQueryClient();
    const invalidate = useCallback(() => {
        const networkKey = getNetworkKey();
        const authTokenKey = getAuthTokenKey();
        // Re-fetch the network
        queryClient.invalidateQueries(networkKey);
        // Re-fetch the auth tokens
        queryClient.invalidateQueries(authTokenKey);
    }, [queryClient]);
    return invalidate;
};
//# sourceMappingURL=useInvalidateNetworkQuery.js.map